// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".special-top-cont[data-v-837ba00a]{border-right:1px solid #707070}", "",{"version":3,"sources":["webpack://./resources/views/Home.vue"],"names":[],"mappings":"AAEA,mCAEI,8BAFJ","sourcesContent":["\r\n\r\n.special-top-cont{\r\n\r\n    border-right: 1px solid #707070;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
